import React from 'react';
import {Link} from 'react-router-dom';

export default function UniversalLink(props) {
    let {to, children, ...rest} = props;

    if (typeof to === 'object') {
        return <Link to={to} {...rest}>{children}</Link>
    }

    let matches = to.match(/\/#(.*)/);
    if (matches && matches[1]) {
        return <Link to={matches[1]} {...rest}>{children}</Link>
    } else {
        return <a href={to} {...rest}>{children}</a>
    }
}


// WEBPACK FOOTER //
// ./src/components/UniversalLink.js